function normalizeCategorySlug(slug) {
    return slug
        .trim()
        .replaceAll(" ", "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");
}

export default normalizeCategorySlug;
